import type { TestId } from '../types/tests.types';

/**
 * `data-testid` should stick like this since it follow the testing library
 * pattern
 * @see https://testing-library.com/docs/dom-testing-library/cheatsheet/#queries
 */
export const getTestId = (id: TestId) => ({ 'data-testid': id });
